'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _typography = require('./styles/typography');

var _colors = require('./styles/colors');

var _reactIcons = require('@rover/react-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyle = function getStyle(isCurrent, isComplete, isFirst, isLast) {
    var baseStyle = _extends({
        display: 'flex',
        flex: '1 1 auto',
        justifyContent: 'center',
        alignItems: 'center',
        height: 35
    }, _typography.text, {
        color: 'white',
        backgroundColor: _colors.chalice
    });

    var declarations = {};

    if (isFirst) {}

    if (isLast) {
        declarations.backgroundColor = '#767676';
    }

    if (isCurrent) {
        declarations.color = 'white';
        declarations.backgroundColor = _colors.turquoise;
        declarations.opacity = '100%';
    }

    if (isComplete) {
        declarations.color = _colors.turquoise;
        declarations.backgroundColor = 'white';
        declarations.opacity = '100%';
    }

    return _extends({}, baseStyle, declarations);
};

var getIcon = function getIcon(isComplete, color) {
    return isComplete ? _react2.default.createElement(_reactIcons.CircleChecked, { fill: color, stroke: color }) : _react2.default.createElement(_reactIcons.CircleUnchecked, { stroke: 'white' });
};

var renderProgressSteps = function renderProgressSteps(color, _onClick, steps) {
    return steps.map(function (_ref, index) {
        var title = _ref.title,
            path = _ref.path,
            isCurrent = _ref.isCurrent,
            isComplete = _ref.isComplete,
            isFirst = _ref.isFirst,
            isLast = _ref.isLast;
        return _react2.default.createElement(
            'div',
            { key: index, style: getStyle(isCurrent, isComplete, isFirst, isLast), onClick: function onClick(e) {
                    return _onClick(path);
                } },
            getIcon(isComplete, color),
            _react2.default.createElement(
                'div',
                { style: { marginLeft: 5, opacity: 1 } },
                title
            )
        );
    });
};

var ProgressBar = function ProgressBar(_ref2) {
    var color = _ref2.color,
        steps = _ref2.steps,
        onClick = _ref2.onClick,
        style = _ref2.style;
    return _react2.default.createElement(
        'div',
        {
            style: _extends({
                display: 'flex',
                borderRadius: 4,
                overflow: 'hidden'
            }, style)
        },
        renderProgressSteps(color, onClick, steps)
    );
};

exports.default = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map